import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WindowService } from './window-service';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private deviceType = new BehaviorSubject<string>(this.getDeviceType());

  constructor(
    private ngZone: NgZone,
    private windowService: WindowService
  ) {
    this.ngZone.runOutsideAngular(() => {
      this.windowService.windowRef.addEventListener(
        'resize',
        this.onResize.bind(this)
      );
    });

    // Initial device type check
    this.deviceType.next(this.getDeviceType());
  }

  getDeviceType(): string {
    const width = this.windowService.windowRef.innerWidth;
    const height = this.windowService.windowRef.innerHeight;
    const devicePixelRatio = this.windowService.windowRef.devicePixelRatio;

    console.log('Current window width:', width); // Debugging line
    console.log('Current window height:', height); // Debugging line
    console.log('Current device pixel ratio:', devicePixelRatio); // Debugging line

    // Consider the iPad Pro 12.9-inch specifically
    const isIpadProLarge =
      (devicePixelRatio === 2 &&
        ((width === 1024 && height === 1366) ||
          (width === 1366 && height === 1024))) ||
      (width === 2048 && height === 2732) ||
      (width === 2732 && height === 2048);

    if (width < 768) {
      return 'mobile';
    } else if (isIpadProLarge || (width >= 768 && width < 1280)) {
      // Expanded tablet range and specific iPad Pro checks
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  getDeviceTypeObservable() {
    return this.deviceType.asObservable();
  }

  private onResize() {
    this.ngZone.run(() => {
      const newDeviceType = this.getDeviceType();
      console.log('New device type:', newDeviceType); // Debugging line
      if (newDeviceType !== this.deviceType.value) {
        this.deviceType.next(newDeviceType);
        console.log('Device type updated to:', newDeviceType); // Debugging line
      }
    });
  }
}
